export { MagicDeleteString, MagicIncrementString, MagicServerTimestampString } from "@ollie-sports/firebase-lift";

// i18n certified - complete
